import { AxiosResponse } from "axios";
import { BaseCandidate } from "./bases/base.service";

export default class CandidateService {
  public login(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseCandidate().post("auth/login", params);
  }
  public request(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseCandidate().post("auth/request", params);
  }
  public reset(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseCandidate().post("auth/reset", params);
  }
}
